import { render, staticRenderFns } from "./ReviewElite.vue?vue&type=template&id=d13dc97e&scoped=true&"
import script from "./ReviewElite.vue?vue&type=script&lang=js&"
export * from "./ReviewElite.vue?vue&type=script&lang=js&"
import style0 from "./ReviewElite.vue?vue&type=style&index=0&id=d13dc97e&prod&lang=css&"
import style1 from "./ReviewElite.vue?vue&type=style&index=1&id=d13dc97e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13dc97e",
  null
  
)

export default component.exports